{
  "account": {
    "biometrics": {
      "download_biometrics": {
        "p1": "Download a copy of my biometric data.",
        "title": "Biometrics Download"
      },
      "face": "Face",
      "iproov_config": {
        "opt_status": {
          "use_iproov": "Use iProov (recommended)",
          "use_standard": "Use an alternative method"
        },
        "p1": "You may opt in or out of using iProov.",
        "save": "Save changes",
        "title": "iProov configuration"
      },
      "manage_biometrics": {
        "options": {
          "download": "Download biometrics",
          "iproov": "iProov configuration"
        },
        "title": "Manage Biometrics"
      },
      "voice": "Voice"
    },
    "delete": {
      "button": "Confirm",
      "key": "DELETE ME",
      "label": "To confirm please type \"DELETE ME\" in all capital letters.",
      "p1": "You may delete your Nomidio ID account.",
      "title": "Delete Account"
    },
    "details": {
      "options": {
        "email": "Email Addresses",
        "names": "First & Last Names",
        "phone": "Phone Numbers"
      },
      "title": "Account Details"
    },
    "edit_details": {
      "alert": {
        "save_error": "There was an error updating your details. Please try again.",
        "save_success": "Account details updated"
      },
      "button": "Save changes",
      "leave_dialog": {
        "cancel": "Cancel",
        "confirm": "Yes",
        "content": "Are you sure you want to leave this page without saving your changes?",
        "title": ""
      },
      "p1": "You may edit your name which is associated with your Nomidio ID",
      "title": "Edit Account Details"
    },
    "email": {
      "approver": {
        "error": {
          "too_many_attempts": "You have made too many incorrect attempts. Please try again later..",
          "wrong_email": "This isn't the email that was entered for your manager. Please check with the person that invited you and try again."
        },
        "manager": {
          "title": "Manager's email address"
        },
        "p1": "When your corporate email was created, a specific manager's email address was nominated for your approver.",
        "p2": "A six-digit verification code will be sent to that manager to approve your email.",
        "title": "Enter manager email"
      },
      "button": "Edit",
      "edit": {
        "add_email": {
          "button": "Add Email"
        },
        "delete_dialog": {
          "cancel": "Cancel",
          "confirm": "Yes",
          "content": "Are you sure you want to delete the following email:",
          "title": ""
        },
        "delete_email": {
          "button": "Delete",
          "error": "There was an error deleting that email address. Please try again."
        },
        "fetch_error": "There was an error retrieving up-to-date email addresses. Please check your internet connection and refresh the page.",
        "new_email": {
          "button": "Send Verification Code",
          "error.corporate_email": "This email is a corporate email. Please contact an enterprise admin to add it to your account.",
          "error.invalid_email": "The email provided is invalid.",
          "error.too_many_requests": "You are sending too many requests. Please wait some time before trying again.",
          "error.unexpected_failure": "There was an error sending a verification code to this email. Please try again.",
          "title": "Add New Email"
        },
        "primary_email": {
          "button": "Make Primary",
          "error": "There was an error updating primary email. Please try again."
        },
        "verify_pending": {
          "button": "Verify"
        }
      },
      "empty": "You do not have any email addresses on your account.",
      "p1": "List of email addresses associated with your Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "The authentication code sent to your email has expired. Please re-submit your email address for verification.",
          "default_content": "We were unable to verify your new email.",
          "email_in_use": "The email you verified is already connected to an account. Please try again with a different email address.",
          "primary_button": "Ok",
          "title": "Verification Unsuccessful"
        },
        "success_dialog": {
          "primary_button": "Ok",
          "title": "Your email has been successfully verified"
        }
      },
      "status": {
        "tooltip": {
          "pending": "This email is pending and needs to be verified.",
          "suspended": "This email is suspended. Please delete or ask the enterprise admin to re-enable this email.",
          "verified": "This email is verified."
        }
      },
      "title": "Email Addresses",
      "type": {
        "corporate": "Corporate",
        "personal": "Personal",
        "primary": "Primary"
      }
    },
    "enrolments": {
      "alert": {
        "save_error": "Enrolment update failed!",
        "save_success": "Enrolment updated!"
      },
      "button": {
        "cancel": "Cancel",
        "retry": "Retry",
        "save": "Update"
      },
      "error": {
        "network_issue": "There seems to be an issue with your internet connection.",
        "server_error": "We are currently experiencing issues. Please try again later."
      },
      "leave_dialog": {
        "cancel": "Cancel",
        "confirm": "Yes",
        "content": "Are you sure you want to leave this page without saving your changes?",
        "title": ""
      },
      "p1": "You have enrolled to use Nomidio ID with these companies.",
      "p2": "You may enrol or de-enrol at any time.",
      "table": {
        "company_header": "Company",
        "enrolled_header": "Enrolled",
        "select_all": "Select All"
      },
      "title": "Manage Enrolled Companies"
    },
    "export": {
      "button": "Download",
      "loading": "Fetching the latest version of your data...",
      "p1": "Download a copy of my personal data.",
      "title": "Data Download"
    },
    "history": {
      "action": {
        "ACCOUNT_DETAILS_UPDATED": "Account details were updated",
        "DATA_REQUESTED": "Requested biometric data",
        "DATA_SHARED": "Shared data",
        "ENROLLED": "Enrolled with an enterprise",
        "FACE_SAMPLE_DOWNLOAD": "Downloaded a face sample",
        "HIGH_CHALLENGE": "Performed high challenge",
        "LOGIN": "Logged in",
        "OPEN_ID_ACCOUNT_APPROVED": "Nomidio ID enterprise sign-in approved",
        "OPEN_ID_ACCOUNT_REMOVED": "Nomidio ID sign-in access removed",
        "OPTED_IN": "Opted in to an enterprise",
        "OPTED_OUT": "Opted out of an enterprise",
        "STANDARD_CHALLENGE": "Performed standard challenge",
        "TERMS_AND_CONDITIONS_ACCEPTED": "Terms and conditions accepted",
        "TERMS_AND_CONDITIONS_REJECTED": "Terms and conditions rejected",
        "VOICE_SAMPLE_DOWNLOAD": "Downloaded a voice sample"
      },
      "button": "Download",
      "p1": "View a list of historic actions on your account.",
      "performedWith": "Performed with: ",
      "title": "Account History"
    },
    "landing": {
      "logout": "Log out",
      "options": {
        "2fa": {
          "add": "Add 2FA Authenticator",
          "loading": "Loading...",
          "update": "Update 2FA Authenticator"
        },
        "account_details": "Account Details",
        "biometrics": "Manage Biometrics",
        "companies": "Enrolled Companies",
        "delete": "Delete my Nomidio ID",
        "device": {
          "settings": "Device settings"
        },
        "export": "Data Download",
        "faq": "FAQ",
        "help": "Help",
        "history": "Account History",
        "privacy": "Privacy Notice",
        "terms": "Terms of Use"
      },
      "title": "Account Management"
    },
    "logout_dialog": {
      "cancel": "Cancel",
      "confirm": "Yes",
      "content": "",
      "title": "Are you sure you want to log out?"
    },
    "phone": {
      "button": "Edit",
      "edit": {
        "delete_dialog": {
          "cancel": "Cancel",
          "confirm": "Yes",
          "content": "Are you sure you want to delete the following number:",
          "title": ""
        },
        "delete_phone": {
          "button": "Delete",
          "error": "There was an error deleting that phone number. Please try again."
        },
        "fetch_error": "There was an error retrieving up-to-date phone numbers. Please check your internet connection and refresh the page.",
        "leave_dialog": {
          "cancel": "Cancel",
          "confirm": "Yes",
          "content": "Are you sure you want to leave this page without saving your changes?",
          "title": ""
        },
        "new_phone": {
          "button": "Verify",
          "error.landline": "Only mobile numbers can be added.",
          "error.unexpected_failure": "There was an error sending a verification code to your phone. Please try again.",
          "title": "Add New Phone Number"
        },
        "phone_list": {
          "title": "Edit Current Phone Numbers"
        },
        "primary_phone": {
          "button": "Make Primary",
          "error": "There was an error updating primary phone. Please try again."
        }
      },
      "empty": "You do not have any phone numbers on your account.",
      "p1": "List of phone numbers associated with your Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "The authentication code sent to your phone has expired. Please re-submit your phone number for verification.",
          "default_content": "We were unable to verify your new phone, it has not been added.",
          "phone_in_use": "The phone number you verified is already connected to an account. Please try again with a different phone number.",
          "primary_button": "Ok",
          "title": "An Error Occurred"
        },
        "success_dialog": {
          "primary_button": "Ok",
          "title": "Your phone has been successfully verified"
        }
      },
      "title": "Phone Numbers",
      "type": {
        "dedicated_landline": "Dedicated Landline",
        "mobile": "Mobile",
        "primary": "Primary",
        "shared_landline": "Shared Landline"
      }
    },
    "totp": {
      "continue": "Create Authenticator Secret",
      "description": "Add two-factor authentication using an authenticator app.",
      "title": "Two-Factor Authentication",
      "verified": {
        "confirm": "Ok",
        "content": "You have successfully added an authenticator to your account.",
        "title": "TOTP Authenticator Added"
      },
      "verify": {
        "authenticator": {
          "p1": "You'll need an authenticator app on your device to proceed with this step. We recommend using an app such as Google Authenticator.",
          "title": "Don't have an authenticator?"
        },
        "button": "Verify",
        "step1": {
          "title": "Step 1. Scan the QR code"
        },
        "step2": {
          "p1": "Enter the 6 digit code displayed in the authenticator app.",
          "p2": "Codes are timed, so be sure to enter it and click verify before it is recycled.",
          "title": "Step 2. Enter your security code"
        },
        "title": "Register an Authenticator"
      },
      "warning": "Creating a new secret will automatically disable an existing one."
    },
    "welcome_dialog": {
      "content": "Your Nomidio ID has been successfully created. You will receive an email with additional account management information.",
      "primary_button": "Ok",
      "title": "Welcome to Nomidio Identity"
    }
  },
  "auth": {
    "login": {
      "landing": {
        "p1": "To authenticate using your Nomidio ID you will need to pass a biometric check.",
        "title": "Welcome to Nomidio ID"
      }
    }
  },
  "avatar": {
    "review": {
      "pending": "Pending approval",
      "rejected": "Rejected",
      "verified": "Verified"
    },
    "upload": {
      "failed": "Unable to set that image as your profile picture.",
      "pending": "Uploading ..."
    }
  },
  "branding": {
    "powered_by_pq": "Powered by Post-Quantum"
  },
  "browser_compatibility": {
    "android_web_view": {
      "li1": "Press the menu in the corner",
      "li2": "Select \"Open in Chrome\"",
      "open": "Please open this link in Chrome or Firefox. You can do so with the following steps:",
      "title": "This in-app browser is not supported."
    },
    "unsupported": {
      "direction": "Please open this link in Chrome or Firefox for Android, or Safari on iOS",
      "open": "It looks like you are using a non-compatible browser.",
      "title": "Unsupported Browser"
    }
  },
  "browser_problem_link": {
    "text": "Problem with browser?"
  },
  "challenge": {
    "pin": {
      "browser": {
        "click": "Click here to copy",
        "error": {
          "incomplete": "It looks like your login was incomplete, please reopen the link and try again.",
          "link": "The link you used was inaccurate.",
          "request": "There was an issue retrieving your pin, please try again later.",
          "unexpected": "An unexpected error occurred whilst retrieving your pin."
        },
        "loading": "Getting your pin",
        "p1": "Thank you for verifying yourself, please copy the code below and enter it in your initial browser.",
        "tap": "Tap here to copy",
        "title": "Return to your initial browser."
      }
    }
  },
  "component": {
    "privacy_statement_link": {
      "link_text": "Privacy Notice"
    }
  },
  "copy": {
    "button": {
      "error": "An error occurred copying, please copy the value manually.",
      "success": "Copied!"
    }
  },
  "document": {
    "button": {
      "skip": "Skip"
    },
    "error": {
      "loading": {
        "faq": "We couldn't load the Frequently Asked Questions at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us.",
        "privacy": "We couldn't load the Privacy Notice at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us.",
        "tnc": "We couldn't load the Terms of Use at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us."
      }
    }
  },
  "email_mfa": {
    "button": {
      "resend": "Resend my verification code",
      "verify": "Verify",
      "verifying": "Verifying..."
    },
    "error": {
      "could_not_send": {
        "button": "request a new one",
        "end": ".",
        "start": "There was an error sending a verification code to your email. Please check your internet connection, then "
      },
      "could_not_verify": "There was an error verifying your pin.  Please check your internet connection, then hit verify again.",
      "resend_limit": "Email resend limit reached.",
      "resent_email": "You have failed too many times with the previous code so a new code has been sent to you. Please try again.",
      "timeout": "Your code has expired. A new code has been sent."
    },
    "instructions": {
      "email_available": "Please enter the 6 digit code which has been sent to this email address.",
      "email_not_available": "Please enter the 6 digit code which has been sent to the email address associated with your account."
    },
    "resend_confirmation": "Verification has been sent.",
    "title": "Verification code"
  },
  "error": {
    "generic": {
      "message": "Please get in touch with us about this.",
      "title": "Something went wrong"
    }
  },
  "export": {
    "filename": "nomidio_id_data"
  },
  "external": {
    "faq": {
      "link": "Link to the FAQ."
    },
    "privacy": {
      "link": "Click the link to your company's Privacy Policy."
    },
    "systemAdmin": {
      "email": "Please contact your system administrator."
    },
    "tnc": {
      "link": "Click the link to your company's Terms of Use."
    }
  },
  "face_check": {
    "check": {
      "biometrics": {
        "upload": "Uploading your biometrics."
      },
      "button": {
        "camera": "Change camera",
        "help": "Help",
        "retry": "Retry"
      },
      "desktop": {
        "tap_to_start": "Click the button below to start recording"
      },
      "instructions": {
        "align": "Position your face in the oval. Make sure we can clearly see your eyes",
        "complete": "Complete",
        "detected": "Hold still!",
        "timed_out": "No face detected"
      },
      "loading": "Loading…",
      "needs_video": "Tap anywhere to activate your webcam",
      "processing": "Processing...",
      "refresh": "Please don't refresh the page.",
      "tap_start": "Tap to start",
      "tap_to_start": "Tap here to start",
      "uploading": "Uploading..."
    },
    "media_access": {
      "button": {
        "allow": "Allow Camera Access"
      },
      "p1": "We need your permission to access the camera in order to capture your biometric faceprint.",
      "p2": "Please allow access to the camera to do this.",
      "title": "Camera Access"
    },
    "media_error": {
      "button": "Refresh",
      "p1": "Please try refreshing the page or updating the camera access permissions within your browser settings.",
      "title": "Camera access denied"
    },
    "orientation_error": {
      "title": "Your device is in landscape mode. Please rotate!"
    }
  },
  "forms": {
    "email": {
      "label": "Email Address"
    },
    "first_name": {
      "error": {
        "maxlength": "First name is too long",
        "pattern": "First name is not valid",
        "required": "First name is required"
      },
      "label": "First name"
    },
    "last_name": {
      "error": {
        "maxlength": "Last name is too long",
        "pattern": "Last name is not valid",
        "required": "Last name is required"
      },
      "label": "Last name"
    }
  },
  "help": {
    "app_version": {
      "end": "",
      "start": "app version: "
    },
    "face_check": {
      "position": "Hold camera at eye level",
      "profile": "Light your face evenly"
    }
  },
  "index": {
    "incompatible": {
      "p1": "This device or browser is not able to run this application.",
      "p2": "You may need to update your software or hardware.",
      "title": "Device not supported"
    }
  },
  "iproov": {
    "failed": "We couldn't verify your face print",
    "processing": "Face biometrics are being processed",
    "timeout": {
      "heading": "Failed to initialise",
      "p1": "Please retry.",
      "p2": "If this problem is persisting, please reload the page."
    }
  },
  "language": {
    "choose": "Choose your language:",
    "cimode": "Debug"
  },
  "login": {
    "bio_intro": {
      "button": "Next",
      "list": {
        "item1": "The space is well lit",
        "item2": "You hold still for 2–4 seconds",
        "item3": {
          "desktop": "You do not cover or obscure your face",
          "mobile": "You hold your device in portrait mode"
        }
      },
      "listStart": "Please make sure:",
      "title": "We will now capture a video to verify your face biometrics"
    },
    "chooseEmail": {
      "error": {
        "p1": "Couldn't load this account's emails.",
        "p2": "This account doesn't have any verified and approved emails.",
        "p3": "Couldn't load this account's emails.",
        "p4": "There was an unexpected server error.",
        "p5": "There was an error submitting your choice.",
        "p6": "Please try again."
      },
      "loading": "Loading emails...",
      "p1": "Your account has multiple emails available to sign in with. Please choose one to proceed.",
      "retry": {
        "button": "Retry"
      },
      "title": "Choose an email to sign in with"
    },
    "deleted_dialog": {
      "content": "Your account has been successfully deleted from our system.",
      "primary_button": "Ok",
      "title": "Account deleted."
    },
    "email": {
      "not_registered": {
        "p1": "It looks like you do not have an account registered with this email address.",
        "p2": "Either you can register with this address, or use a different email address.",
        "register_button": "Register",
        "retry_button": "Try Again",
        "title": "No account"
      }
    },
    "error": {
      "same_browser": {
        "p1": "It looks like you opened this link in the same browser you started in. To continue signing in, open the link on the supported browser or device you're switching to.",
        "title": "Please use your other browser"
      }
    },
    "failed_dialog": {
      "content": "We were unable to verify your identity",
      "primary_button": "Ok",
      "server_error": "We are currently experiencing issues. Please try again later.",
      "title": "Login error."
    },
    "landing": {
      "button": {
        "login": "Login",
        "register": "Register"
      },
      "error": {
        "account_locked": "Your account is currently locked, please try later.",
        "auth_bad_state": "Failed to start Auth session.",
        "fail_into_key_recovery": "There was a problem logging you in. You will need to log in with your email.",
        "forbidden": "You are not authorised for login to this application.",
        "generic": "There was a problem logging you in.",
        "invalid_credentials": "Invalid credentials provided.",
        "invalid_email": "Invalid email provided.",
        "login_timeout": "Your session has ended. Please log back in to continue.",
        "max_mfa_reached": "OTP resend limit reached.",
        "oauth_bad_state": "Could not verify OAuth2 session, please return to the login screen.",
        "recovery_server_error": "Your account could not be recovered due to a server error, please try later.",
        "too_many_attempts": "We have detected this device has requested too many login attempts. Please try again in 10 minutes.",
        "unexpected_failure": "There was a problem logging you in. Please check your internet connection and try again.",
        "verification_image_error": "There was a problem loading verification image.",
        "verification_image_match": "The verification images linking logins across browsers need to match.",
        "webauthn_cancelled": "The passkey request was cancelled. Please try again to log in."
      },
      "key_recovery": {
        "p1": "To manage your Nomidio ID you will need to authenticate yourself via face and voice recognition checks.",
        "p2": "Please log in with your registered email address."
      },
      "normal": {
        "p1": "To manage your Nomidio ID you will need to authenticate yourself via face and voice recognition checks."
      },
      "privacy_link": "Privacy Notice",
      "terms_link": "Terms of Use",
      "title": "Welcome to your Nomidio ID"
    },
    "oauthEnded": {
      "body": "You may now close this window.",
      "title": "Login complete"
    },
    "polling": {
      "button": {
        "continue": "Ok",
        "start_poll": "Continue"
      },
      "network_issue": "There seems to be an issue with your internet connection.",
      "p1": "This may take a few seconds. Please don't refresh the page.",
      "server_error": "We are currently experiencing issues. Please try again later.",
      "time_out": "It is taking longer than we expected to process your biometric information. Either continue waiting or try again later.",
      "title": "We're verifying your identity."
    },
    "retry": {
      "button": "Retry",
      "p1": "Please try again",
      "title": "We couldn't verify you"
    },
    "webauthn": {
      "button": "Create my key",
      "details": "This will help us verify it's you, and let you verify yourself quickly in the future.",
      "dialog": "You may need to confirm this action with your browser or password vault.",
      "error": "That didn't work. Try again?",
      "title": "Create a key"
    }
  },
  "mfa": {
    "EMAIL": {
      "backup": "I cannot access my email",
      "error.could_not_send.button": "request a new one",
      "error.could_not_send.end": ".",
      "error.could_not_send.start": "There was an error sending a verification code to your email. Please check your internet connection, then ",
      "error.invalid_email": "Email provided is invalid.",
      "error.resend_limit": "Email resend limit reached.",
      "instructions.p1": "You have been sent an email containing a 6 digit code.",
      "instructions.p2": "Please enter the 6 digit code.",
      "resend": "Resend my email verification code",
      "resent": "A new code has been emailed to you.",
      "title": "Email Verification Code"
    },
    "PHONE": {
      "backup": "",
      "error.could_not_send.button": "request a new one",
      "error.could_not_send.end": ".",
      "error.could_not_send.start": "There was an error sending a verification code to your phone number. Please check your internet connection, then ",
      "error.resend_limit": "SMS resend limit reached.",
      "instructions.p1": "Please enter the 6 digit code sent in the SMS text message to this phone number.",
      "instructions.p2": "",
      "resend": "Resend my text verification code",
      "resent": "A new code has been sent to you.",
      "title": "Phone Verification Code"
    },
    "TOTP": {
      "backup": "I cannot access my authenticator app",
      "instructions.p1": "Please enter the 6 digit code displayed in your authenticator app.",
      "instructions.p2": "Codes are time limited, so be sure to enter it and click verify before it expires.",
      "resend": "",
      "title": "Two-Factor Authentication Code"
    },
    "verify": "Verify",
    "verifying": "Verifying..."
  },
  "mobile": {
    "download": {
      "hint": "If you are having trouble downloading files to your mobile device, please try again on a desktop device."
    }
  },
  "nomidio": {
    "input": {
      "error": {
        "email": "Must be a valid email",
        "exactlength": "Must have exact length of ",
        "forbidden": "This value is not permitted",
        "max": "Must be no more than ",
        "maxlength": "Must be at most length ",
        "min": "Must be at least ",
        "minlength": "Must be at least length ",
        "otp": {
          "exactlength": " digits required",
          "pattern": "Code must be numbers only",
          "required": "Code is required",
          "retry": "Incorrect code"
        },
        "pattern": "This value is not valid",
        "phone": "Must be a valid phone number",
        "required": "This field is required"
      }
    },
    "phone": {
      "error": "Please choose a different phone number",
      "number": "Phone Number"
    }
  },
  "oauth": {
    "abort": {
      "continue": "Return",
      "p1": "Required data sharing was not approved, login has been aborted.",
      "p2": "Login has been aborted.",
      "title": "Login Aborted"
    },
    "approval": {
      "button": {
        "accept": "Accept",
        "decline": "Decline"
      },
      "checkbox": {
        "openid": "I consent to using Nomidio ID"
      },
      "default": {
        "p1": {
          "end": ".",
          "middle": " has requested sharing your Nomidio ID data with ",
          "start": ""
        }
      },
      "openid": {
        "p1": {
          "end": ". Please review the following conditions:",
          "middle": " would like to use your Nomidio ID to access ",
          "start": ""
        }
      },
      "p2": "The following data will be shared:",
      "privacy_policy": {
        "end": ".",
        "link": "click here",
        "start": "For more details on how your data may be used "
      },
      "scope": {
        "email": "Email",
        "profile": "First and last name"
      },
      "title": "Approval"
    },
    "error": {
      "continue": "Return",
      "description": {
        "400": "You failed one or more checks.",
        "401": "You failed one or more checks.",
        "403": "You are not authorised for login to this application.",
        "404": "Third party login state missing. This may be resolved by trying to log in again.",
        "409": "Your session has expired, please try again.",
        "429": "You reached a verification limit. This may hinder logins in the next day.",
        "500": "An error occurred either on the website or server, please try to log in again.",
        "undefined": "An error occurred either on the website or server, please try to log in again."
      },
      "p1": "You have failed to authenticate. Please see the error breakdown below for more.",
      "title": "Login Failed"
    },
    "login": {
      "landing": {
        "p1": "To login using your Nomidio ID you will need to pass a biometric check.",
        "title": "Welcome to Sign-In with Nomidio ID"
      }
    }
  },
  "phone_mfa": {
    "button": {
      "resend": "Resend my verification code",
      "verify": "Verify",
      "verifying": "Verifying..."
    },
    "error": {
      "conflict": "Phone number already in use.",
      "could_not_send": {
        "button": "request a new one",
        "end": ".",
        "start": "There was an error requesting an SMS verification code. Please check your internet connection, then "
      },
      "could_not_verify": "There was an error verifying your pin. Please check your internet connection, then hit verify again.",
      "resend_limit": "SMS resend limit reached.",
      "resent_code": "You have failed too many times with the previous code so a new code has been sent to you. Please try again.",
      "timeout": "Your code has expired. A new code has been sent."
    },
    "instructions": {
      "p1": "Please enter the 6 digit code sent in the SMS text message to this phone number."
    },
    "new_pin_dialog": {
      "content": "You will receive an SMS with a new 6 digit code",
      "primary_button": "Ok",
      "title": "Invalid code."
    },
    "resend_confirmation": "Verification has been sent.",
    "title": "Phone verification code"
  },
  "register": {
    "account_details": {
      "button": "Next",
      "intro": "Please enter your name so that we can create your Nomidio ID.",
      "title": "Account Details"
    },
    "bio_intro": {
      "button": "Start",
      "list": {
        "item1": "You are in a quiet place",
        "item2": "You can speak freely",
        "item3": "The space is well lit",
        "item4": "There is no bright light directly behind you",
        "item5": {
          "desktop": "You do not cover or obscure your face",
          "mobile": "Your device is in portrait mode"
        }
      },
      "listStart": "Please make sure:",
      "title": "When capturing your biometric data for the creation of your Nomidio ID, please make sure that…"
    },
    "consent": {
      "button": {
        "accept": "Accept",
        "decline": "Decline"
      },
      "checklist": {
        "general": "I consent to my personal information being used to create my Nomidio ID.",
        "general_enrol": {
          "end": ".",
          "start": "I consent to my personal information being used to create my Nomidio ID and to enrolling my Nomidio ID with "
        },
        "privacy": {
          "end": ".",
          "link": "Privacy Notice",
          "start": "I confirm that I have reviewed the "
        },
        "terms": {
          "end": ".",
          "link": "Terms of Use",
          "start": "I confirm that I have reviewed and accept the "
        },
        "title": "You must agree to the following to proceed:"
      },
      "decline_dialog": {
        "cancel": "Cancel",
        "confirm": "Yes",
        "content": "You will not be able to create an Nomidio ID",
        "title": "Are you sure you want to decline?"
      },
      "error": {
        "bad_request": "This should not happen, but your invitation appears to be invalid.",
        "conflict": "Unfortunately your invitation cannot be accepted, perhaps it has expired or has been completed.",
        "forbidden": "Unfortunately your invitation cannot be accepted, perhaps your phone number is blocked.",
        "unexpected_error": "Unfortunately an unexpected error has occurred, please try again."
      },
      "intro": {
        "enrol": {
          "end": " when you complete this registration.",
          "start": "We will enrol your Nomidio ID with "
        },
        "p1": "To create your Nomidio ID we will need to collect your name, mobile number and email address, as well as your biometric voiceprint and faceprint. We will use this to help you verify your identity with other companies. We will always ask for your permission before verifying your identity with a new company and we will never share your biometric data with anyone unless required to do so by law.",
        "p2": "When we verify your identity we may send you an SMS text message with a verification code or link.",
        "withdraw": "You will be able to withdraw your consent and manage your other privacy preferences via the web application at any time."
      },
      "submitting": "Please wait a moment.",
      "title": "We need your consent"
    },
    "consent_declined": {
      "p1": "You will not be able to use Nomidio Identity.",
      "title": "You have declined the Terms of Use"
    },
    "email": {
      "already_verified": {
        "p1": "Please enter your email address. In order to resume registration, email verification pin is required."
      },
      "button": "Send Verification Code",
      "error": {
        "already_used": "The provided email address is already in use by another user, please try again with a different email.",
        "corporate_email": "This email is a corporate email. Please contact an enterprise admin to add it to your account.",
        "email_mismatch": "You will need to verify the email address that is assigned to this registration. You can change your email address after completing registration.",
        "invalid_email": "The provided email is invalid.",
        "max_retry": "Verification code resend limit reached.",
        "sending_email": "There was an error sending a verification code to your email. Please try again.",
        "too_many_requests": "You are sending too many requests. Please wait some time before trying again."
      },
      "expired_notice": "The authentication code sent to your email has expired. Please re-submit your email for verification.",
      "p1": "Please enter your email address. You will be sent a 6 digit code that must be entered in order to link your email address to your Nomidio ID account.",
      "title": "Account Details"
    },
    "email_confirmed": {
      "primary_button": "Ok",
      "title": "Your email has been successfully verified"
    },
    "expired": {
      "p1": "You took too long to complete your session.",
      "p2": "You may leave this page.",
      "title": "Sorry, this invitation has expired"
    },
    "face": {
      "camera": {
        "content": "Choose a connected camera from your list.",
        "error": {
          "content": "You may need to pick a different video source.",
          "title": "Can't use this camera"
        },
        "save": "Save",
        "title": "Change Camera"
      }
    },
    "face_failed": {
      "button": "Retry",
      "error": {
        "bad_contrast": "Your faceprint has poor contrast, please try again.",
        "bad_dynamic_range": "Your faceprint is poorly lit and has low contrast, please try again.",
        "bad_exposure": "The exposure of your faceprint is not strong enough, please try again.",
        "bad_lighting": "Your faceprint has poor lighting, please try again in a better lit environment.",
        "bad_object": "Your faceprint was not good enough for biometric processing, please try again.",
        "bad_pose": "Please retry by holding your camera upright.",
        "bad_sharpness": "Please retry by holding your camera firmly.",
        "expired": "Your challenge or invitation has expired.",
        "internal_error": "An unexpected error has occurred, please try again. Error code: INTERNAL_ERROR.",
        "invalid_media": "We were unable to process this faceprint, please try again.",
        "invalid_sample_resolution": "The resolution of your faceprint was not high enough, please try again.",
        "object_not_found": "Unable to clearly detect your face, please try again.",
        "occlusion": "It looks like something got in the way of your face, please try again.",
        "too_few_features": "Unable to detect your face in enough detail, please try again.",
        "too_few_objects": "Your faceprint did not contain enough detail to process, please try again.",
        "too_noisy": "The quality of your faceprint was not good enough for biometric processing, please try again.",
        "unknown": "An unexpected error has occurred, please try again.",
        "user_not_active": "An unexpected error has occurred, please try again. Error code: USER_NOT_ACTIVE."
      },
      "title": "We couldn’t successfully capture your faceprint"
    },
    "iproov": {
      "retry": "Retry"
    },
    "landing": {
      "button": "Get Started",
      "error": {
        "invalid": "This invitation is not valid. Check you accessed the most recent link.",
        "session": "The registration session expired. Please re-submit your details."
      },
      "p1": "Prove your identity to trusted companies and control the data you share with them.",
      "title": "Create Your Nomidio ID"
    },
    "link": {
      "failed_dialog": {
        "primary_button": "Ok"
      }
    },
    "oauth_final": {
      "p1": {
        "end": " to login with your newly created account.",
        "start": "You are now successfully registered. Please return to "
      },
      "title": "Registration Complete"
    },
    "phone": {
      "already_verified": {
        "p1": "Please enter your phone number. In order to resume registration, phone verification pin is required."
      },
      "button": "Send Verification Code",
      "error": {
        "already_used": "The provided phone number is already in use by another user, please try again with a different phone number.",
        "invalid_mobile": "This is not a valid mobile number.",
        "max_retry": "Verification code resend limit reached.",
        "phone_mismatch": "You will need to verify the phone number that is assigned to this registration. You can change your phone number after completing registration.",
        "sending_phone": "There was an error sending a verification code to your phone. Please try again.",
        "too_many_requests": "You are sending too many requests. Please wait some time before trying again."
      },
      "expired_notice": "The authentication code sent to your phone has expired. Please re-submit your phone number for verification.",
      "p1": "Please enter your phone number. You will be sent a 6 digit code that must be entered in order to link your phone to your Nomidio ID account.",
      "skip": "Skip",
      "title": "Account Details"
    },
    "phone_confirmed": {
      "button": "Ok",
      "title": "Your phone number has been successfully verified"
    },
    "post_creation": {
      "continue": "Continue",
      "option": {
        "avatar": {
          "cta": "Upload",
          "desc": "Personalise your account by adding an avatar.",
          "label": "Upload a profile picture"
        },
        "totp": {
          "cta": "Set Up",
          "desc": "Add an extra layer of security to your account.",
          "label": "Add Two-Factor Authentication"
        }
      },
      "p1": "Your account has been created. You can add the following optional details now, or set them up later.",
      "title": "You're all set"
    },
    "redirect": {
      "link": "click here",
      "p1": "You have completed registration and will now be redirected for the next part of the process.",
      "p2": "This should take only a few seconds. If nothing happens, please ",
      "title": "Redirecting..."
    },
    "renew": {
      "button": "Resume",
      "error": {
        "could_not_renew": "We could not renew your invitation. Please try again."
      },
      "p1": "This registration was left for a long time before completion. You'll need to re-do part of the registration.",
      "title": "Resuming registration"
    },
    "skip": {
      "interaction": "Don't show this to me again"
    },
    "summary": {
      "button": "Submit",
      "email": "Email",
      "name_edit": "Edit",
      "phone": "Mobile number",
      "title": "Verify Personal Data"
    },
    "totp": {
      "p1": "Add two-factor authentication using an authenticator app",
      "qr": {
        "loading": "Loading QR code..."
      },
      "step1": {
        "title": "Step 1. Scan the QR code"
      },
      "step2": {
        "title": "Step 2. Enter your security code"
      },
      "submit": "Confirm",
      "title": "Two-Factor Authentication"
    },
    "verify_face": {
      "failed": {
        "button": "Retry",
        "p1": "We couldn't verify your biometrics, please try again.",
        "title": "Failed!"
      },
      "intro": {
        "button": "Continue",
        "option": {
          "iproov.desc": "Fastest and most secure method.",
          "iproov.label": "Use iProov verification",
          "recommended": "Recommended",
          "standard.desc": "This process may take longer.",
          "standard.label": "Use an alternative method"
        },
        "p1": "To confirm your account is secure, we need to confirm your identity using a quick biometric scan.",
        "p2": {
          "href": "https://www.iproov.com/blog/iproov-safeguards-for-people-with-photosensitive-epilepsy",
          "part1": "We use ",
          "part2": "iProov",
          "part3": ", a secure biometric verification service. iProov uses your device's camera and may include a brief sequence of flashing lights to confirm you are a real person.",
          "title": "How does it work"
        },
        "p3": "You can update your consent anytime in your account settings.",
        "title": "Verifying your face"
      },
      "opt_out_dialog": {
        "cancel": "Cancel",
        "confirm": "Opt out",
        "p1": "By opting out of iProov verification, you'll need to verify your identity using an alternative method, which may take more time.",
        "p2": "Do you still want to opt out of using iProov?",
        "title": "Opt out"
      },
      "retry": {
        "p2": "You will need to re-register your biometrics.",
        "title": "Repeat Biometric"
      }
    },
    "verify_voice": {
      "failed": {
        "button": "Retry",
        "p1": "We couldn't complete your voice print. Please try again.",
        "title": "Failed!"
      }
    },
    "webauthn": {
      "button": "Create my key",
      "details": "This will help us verify it's you, and let you verify yourself quickly in the future.",
      "dialog": "You may need to confirm this action with your browser or password vault.",
      "error": "That didn't work. Try again?",
      "title": "Create a key"
    }
  },
  "registration": {
    "consent": {
      "button": {
        "accept": "Accept",
        "decline": "Decline"
      },
      "checklist": {
        "general": "I consent to my personal information being used to create my Nomidio ID.",
        "privacy": {
          "end": ".",
          "link": "Privacy Notice",
          "start": "I confirm that I have reviewed the "
        },
        "terms": {
          "end": ".",
          "link": "Terms of Use",
          "start": "I confirm that I have reviewed and accept the "
        },
        "title": "You must agree to the following to proceed:"
      },
      "intro": {
        "p1": "To create your Nomidio ID we will need to collect your name, mobile number and email address, as well as your biometric voiceprint and faceprint. We will use this to help you verify your identity with other companies. We will always ask for your permission before verifying your identity with a new company and we will never share your biometric data with anyone unless required to do so by law.",
        "p2": "When we verify your identity we may send you an SMS text message with a verification code or link.",
        "p3": "You will be able to withdraw your consent and manage your other privacy preferences via the web application at any time."
      },
      "title": "We need your consent"
    },
    "creating": {
      "p1": "We're setting up the rest of your registration, please wait.",
      "title": "Creating your registration"
    },
    "email": {
      "button": "Send Verification Code",
      "error": {
        "already_used": "The provided email address is already in use by another user, please try again with a different email.",
        "invalid_email": "The provided email is invalid.",
        "unexpected_failure": "There was an error sending a verification code to your email. Please try again."
      },
      "expired_notice": "The authentication code sent to your email has expired. Please re-submit your email for verification.",
      "p1": "Please enter your email address. You will be sent a 6 digit code that must be entered in order to verify your email.",
      "title": "Email"
    },
    "error": {
      "corporate_email": {
        "button": {
          "retry": "Use Different Email"
        },
        "p1": "The email you have provided is a corporate email. Please contact an enterprise admin to add it to your account.",
        "p2": "You should register using a personal email.",
        "title": "Corporate Email"
      },
      "email_in_use": {
        "button": {
          "login": "Login",
          "retry": "Use Different Email"
        },
        "p1": "The email you verified is already connected to an account.",
        "p2": "You may try to register using a different email or log in with your verified email.",
        "title": "Email in Use"
      },
      "email_phone_in_use": {
        "button": {
          "retry": "Use Different Details"
        },
        "p1": "Both the email and phone number you verified are already connected to accounts.",
        "p2": "You may try to register different details.",
        "title": "Phone and Email in Use"
      },
      "email_restricted": {
        "p1": "You are not authorised to register with this link.",
        "title": "Registration Forbidden"
      },
      "invalid_domain": {
        "p1": "We could not find the link you used, this could be because the link does not exist, or the link has not been activated.",
        "p2": "Unfortunately you cannot proceed with registration.",
        "title": "Registration link not found"
      },
      "link_not_found": {
        "p1": "We could not find the link you used, this could be because the link does not exist, or the link has expired.",
        "p2": "Unfortunately you cannot proceed with registration.",
        "title": "Registration link not found"
      },
      "phone_in_use": {
        "button": {
          "login": "Login",
          "retry": "Use Different Number"
        },
        "p1": "The phone number you verified is already connected to an account.",
        "p2": "You may try to register using a different phone number or log in to the existing account.",
        "title": "Phone number in Use"
      },
      "server_error": {
        "button": "Try Again",
        "p1": "We are currently experiencing issues registering you, please wait then try again.",
        "title": "Server Error"
      },
      "session_expired": {
        "button": "Restart",
        "p1": "The registration session expired. Please re-submit your details.",
        "title": "Session Expired"
      },
      "too_many_requests": {
        "p1": "You are sending too many requests. Unfortunately you cannot proceed with registration.",
        "title": "Too Many Requests"
      },
      "user_already_registered": {
        "button": {
          "login": "Login"
        },
        "p1": "The email and phone number you verified are already connected to an account.",
        "title": "User Already Registered"
      }
    },
    "phone": {
      "button": "Send Verification Code",
      "error": {
        "invalid_mobile": "This is not a valid mobile number."
      },
      "p1": "Please enter your mobile number. You will be sent a 6 digit code which must be entered in order to verify your mobile number.",
      "title": "Mobile Number"
    }
  },
  "shared": {
    "notFound": {
      "p1": "The page you requested was not found.",
      "title": "Not Found"
    }
  },
  "theme": {
    "color": {
      "title": "Color scheme"
    },
    "picker": {
      "dark": "Dark mode",
      "light": "Light mode",
      "system": "System"
    }
  },
  "title": "Nomidio Identity",
  "topmenu": {
    "back": "Go back",
    "help": "View FAQ",
    "logo": {
      "alt": "Nomidio Identity"
    },
    "switch_user": "Switch user"
  },
  "totp_code": {
    "copied_secret": "Secret Copied",
    "copy_secret": "Copy Secret",
    "p1": "Scan the QR code with your authenticator app or manually enter the secret.",
    "p2": "On a mobile device, you can tap the QR code to configure Google Authenticator (if it is installed).",
    "view_qr": "View QR",
    "view_secret": "View Secret"
  },
  "unsupported": {
    "browser": {
      "challenge": {
        "error": {
          "preselected": "You have already selected a challenge image.",
          "unexpected": "An unexpected error occurred whilst selecting image."
        }
      },
      "code": {
        "error": {
          "challenge": "Login on supported browser is not completed yet",
          "invalid": "Submitted code was invalid",
          "unexpected": "An unexpected error occurred whilst verifying your code"
        }
      },
      "copy": {
        "button": "Copy link to clipboard"
      },
      "error": {
        "auth": "Failed to retrieve login url, missing auth code.",
        "server": "Failed to retrieve login url due to server error, please try later."
      },
      "image": {
        "button": "Select Image"
      },
      "p1": "Looks like you are using an unsupported browser. You can still complete a login via another browser by following the instructions.",
      "step1": {
        "p1": "For security purposes, pick an image which will be used to link the login across browsers.",
        "title": "Step 1. Select image"
      },
      "step2": {
        "p1": "Complete login on supported browser with microphone and camera access via the link in order to get verification code.",
        "p2": {
          "part1": "Scan the QR code or copy ",
          "part2": " into a supported browser."
        },
        "p3": "The image you picked in step 1 should be shown.",
        "title": "Step 2. Login via Link"
      },
      "step3": {
        "p1": "Upon successful login, a verification code will be displayed. Please enter the code below.",
        "title": "Step 3. Enter Verification Code"
      }
    }
  },
  "user_details_dialog": {
    "a": "Why do I have to do this?",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "p1": "To confirm your identity without 2FA or email verification, you will need to provide additional account details.",
    "p2": {
      "phone": "Please enter your primary phone number below to continue."
    },
    "title": "We need some information"
  },
  "voice_check": {
    "dialog": {
      "mic_troubleshoot": {
        "list": {
          "item1": "Your microphone is unmuted.",
          "item2": "You're not using your microphone already for a voice call.",
          "item3": "The correct microphone is selected.",
          "item4": "You're speaking clearly into your microphone."
        },
        "ok": "Ok",
        "p1": "Please ensure:",
        "p2": "Your page will now reload.",
        "title": "No audio detected"
      }
    },
    "media_access": {
      "button": "Allow Microphone Access",
      "p1": "We need your permission to access the microphone to capture your biometric voiceprint.",
      "p2": "Please allow access to the microphone to do this.",
      "title": "Microphone Access"
    },
    "media_error": {
      "button": "Refresh",
      "p1": "Please try refreshing the page or updating the microphone access permissions within your browser settings.",
      "title": "Microphone access denied"
    },
    "record": {
      "hint": {
        "firstRecording": "Tap the record button and say the phrase below, then tap again to stop.",
        "polling": "Checking with the server ...",
        "tapAgain": "Tap again to finish recording",
        "tooLong": "That took too long. You need to tap the record button to end the recording.",
        "tooQuiet": "We couldn't pick up any audio.",
        "tooShort": "That was too short. You need to speak slower.",
        "training2": "Now record the phrase again",
        "verification1": "Now we need to verify things are set up correctly. Record the phrase again.",
        "verification2": "Now record the phrase again",
        "waitingForUploads": "Waiting for uploads to complete ..."
      },
      "phrase": "“I use my voice to prove my identity”",
      "recordButtonText": {
        "tapStart": "Tap to start",
        "tapStop": "Tap to stop",
        "uploading": "Uploading"
      }
    }
  }
}
